// extracted by mini-css-extract-plugin
module.exports = {"appleScrollbar":"mixins_appleScrollbar__BnxwD"};